import React, { useState } from 'react'
import { Copy, Check } from 'lucide-react'

// Botão pequeno para copiar texto (ex: EAN) para o clipboard com 1 clique.
// Mostra "✓" durante 1.2s ao copiar; ignora cliques que se propagariam (ex: linhas
// da tabela com onClick para abrir modal).
export function CopyButton({ text, size = 12, title = 'Copiar', color = '#605e5c' }) {
  const [copied, setCopied] = useState(false)

  const onClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (!text) return
    const value = String(text)
    const finish = () => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1200)
    }
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value).then(finish).catch(() => {})
    } else {
      // Fallback antigo
      const ta = document.createElement('textarea')
      ta.value = value
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand('copy'); finish() } catch {}
      document.body.removeChild(ta)
    }
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title={copied ? 'Copiado!' : title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: copied ? '#107c10' : color,
        padding: '0 4px',
        verticalAlign: 'middle',
        opacity: copied ? 1 : 0.65,
        lineHeight: 0,
      }}
    >
      {copied ? <Check size={size} /> : <Copy size={size} />}
    </button>
  )
}
